import { useMemo } from 'react';

export const useEventsData = (initialData) => {
  // Handle error state
  const hasError = initialData?.error;

  // Separate events and partnered events
  const { events, partneredEvents } = useMemo(() => {
    const allEvents = initialData?.data || [];
    return {
      events: allEvents.filter(event => event.event_partnered !== 'Y'),
      partneredEvents: allEvents.filter(event => event.event_partnered === 'Y'),
    };
  }, [initialData]);

  // Transform events data for React Table
  const tableData = useMemo(() => {
    if (!events) return [];
    return events.map((event) => ({
      eventImageUrl: event.event_image_url,
      imageAltText: event.event_image_alt_text,
      eventTitle: event.event_title,
      eventContent: event.event_content,
      eventWhen: event.event_when,
      eventDate: event.event_date,
      eventType: event.event_type,
      eventSlug: event.event_slug,
      eventUrl: event.event_url,
    }));
  }, [events]);

  // Process and sort table data by date
  const processedTableData = useMemo(() => {
    return tableData
      .map((event) => ({
        ...event,
        safeEventContent: event.eventContent,
      }))
      .sort((a, b) => new Date(b.eventDate) - new Date(a.eventDate));
  }, [tableData]);

  return {
    hasError,
    events,
    partneredEvents,
    processedTableData,
  };
};
